// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"ade83621b88d8fcd9574","655":"11ddacfb2c8cba714468"}[chunkId] + ".js";
};